"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileuploadComponent = void 0;
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var FileuploadComponent = /** @class */ (function (_super) {
    __extends(FileuploadComponent, _super);
    function FileuploadComponent() {
        var _this = _super.call(this, constants_1.DATA_FORM_UPLOADWRAPPER) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.formuploadWrapper = document.querySelectorAll("[".concat(constants_1.DATA_FORM_UPLOADWRAPPER, "]"));
        _this.fileuploadFilename = document.querySelectorAll("[".concat(constants_1.DATA_FILEUPLOAD_FILENAME, "]"));
        _this.customFileupload = document.querySelectorAll("[".concat(constants_1.DATA_CUSTOM_FILEUPLOAD, "]"));
        _this.customFileuploadFilename = document.querySelectorAll("[".concat(constants_1.DATA_CUSTOM_FILEUPLOAD_FILENAME, "]"));
        _this.fileuploadDefaultFilename = document.querySelectorAll("[".concat(constants_1.DATA_FILEUPLOAD_DEFAULTFILENAME, "]"));
        _this.fileuploadDelete = document.querySelectorAll("[".concat(constants_1.DATA_FILEUPLOAD_DELETE, "]"));
        _this.customFileupload.forEach(function (element, index) {
            element.addEventListener('change', function () {
                _this.getFilename(element, index);
            });
            _this.fileuploadDelete[index].addEventListener('click', function () {
                var _a;
                var defaultTextElement = _this.fileuploadDefaultFilename[index];
                var defaultFileName = defaultTextElement.innerHTML;
                (_a = _this.fileuploadDelete[index].querySelector("[type=\"hidden\"]")) === null || _a === void 0 ? void 0 : _a.remove();
                element.value = '';
                _this.fileuploadFilename[index].innerHTML = defaultFileName;
                _this.fileuploadDelete[index].classList.add('is-hidden');
                _this.formuploadWrapper[index].classList.remove('filled');
            });
        });
        return _this;
    }
    FileuploadComponent.prototype.getFilename = function (element, index) {
        var defaultTextElement = this.fileuploadDefaultFilename[index];
        var defaultFileName = defaultTextElement.innerHTML;
        // Get selected filename on change
        var currentValue = element.value.split('\\').pop();
        // Add Filename to span (WIP) cant add to hidden div :(
        if (currentValue.length !== 0) {
            this.formuploadWrapper[index].classList.add('is-filled');
            if (document.body.clientWidth < 500) {
                if (currentValue.length > 16) {
                    currentValue = currentValue.substring(0, 16) + '...';
                }
            }
            else {
                if (currentValue.length > 30) {
                    currentValue = currentValue.substring(0, 30) + '...';
                }
            }
            this.fileuploadFilename[index].innerHTML = currentValue;
            this.fileuploadDelete[index].classList.remove('is-hidden');
        }
        else {
            this.fileuploadFilename[index].innerHTML = defaultFileName;
            this.fileuploadDelete[index].classList.add('is-hidden');
            this.formuploadWrapper[index].classList.remove('is-filled');
        }
    };
    return FileuploadComponent;
}(abstractComponent_1.default));
exports.FileuploadComponent = FileuploadComponent;
